<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="设置"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="main">
        <div v-if="modifyPassword" class="change-password-parent" @click="changePassword">
          <div class="change-password-hint">修改密码</div>
          <van-icon class="icon" name="arrow" />
        </div>
        <!-- <div class="change-password-parent" @click="changeBindWX">
          <div class="change-password-hint">绑定微信</div>
          <van-icon class="icon" name="arrow" />
        </div> -->
        <!-- <div class="change-password-parent" @click="doUnBind">
          <div class="change-password-hint">解绑微信</div>
          <van-icon class="icon" name="arrow" />
        </div> -->
      </div>
      <!-- <div class="logout" @click="logout">退出登录</div> -->
      <div style="margin: 16px">
        <van-button class="logout" @click="logout" round block type="info"
          >退出登录</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant'
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as constants from '../../api/constant'
export default {
  data () {
    return {
      modifyPassword: true
    }
  },
  mounted () {
    try {
      const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))
      if (configData && configData.login_method && configData.login_method.yuen === 0) {
        // 不支持系统账号登录时, 不支持修改密码
        this.modifyPassword = false
      }
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    logout () {
      Dialog.confirm({
        title: '确定退出登录？',
        message: ''
      })
        .then(async () => {
          try {
            await this.oauthLogout()
            await api.axiosRequest(api.urlList.logout)
          } catch (e) {
            console.log(e)
          }
          this.execJumpLogin()
        })
        .catch(() => {
          // on cancel
        })
    },
    async oauthLogout () {
      const h5Config = this.$store.state.h5Config
      const channel = h5Config && h5Config.h5Config && h5Config.h5Config.funCfg && h5Config.h5Config.funCfg.oauthLoginChannel
      if (channel) {
        try {
          const para = {
            channel
          }
          const result = await api.axiosRequest(api.urlList.oauthLogout, para)
          if (result.code === common.resCode.OK) {
            if (result.url && result.redirect) {
              location.href = result.url
            } else {
              return result
            }
          }
        } catch (e) {
          console.log('可能没有统一认证退出的接口', e)
        }
      }
    },
    execJumpLogin () {
      api.removeAccessToken()
      this.$store.commit(constants.MSGBADGE, null)
      this.$store.commit(constants.USERINFO, null)
      this.$store.commit(constants.FACE, null)
      this.$store.commit(constants.H5CONFIG, null)
      this.$router.replace('/login')
    },
    changePassword () {
      this.$router.push('./updatePassword')
    },
    changeBindWX () {
      this.$router.push('./bindWechat')
    },
    doUnBind () {
      this.$router.push('./unBindWechat')
    },
    onClickLeft () {
      //   Toast('返回')
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .change-password-parent {
    height: 4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-left: 1rem;
    padding-right: 1rem;
    background-color: #fff;
  }
  .change-password-hint {
    color: #000;
    font-size: 1rem;
    font-weight: bold;
  }
  .icon {
    color: #919191;
  }
  .logout {
    // height: 3.1875rem;
    // width: 100%;
    margin-top: 2.5rem;
    // line-height: 3.1875rem;
    // text-align: center;
    // color: #007dff;
    // font-size: 1rem;
    // background: #fff;
  }
}
</style>
